export default "__VITE_ASSET__3098f612__"